import React, { Component } from 'react';
import { connect } from 'react-redux';
import style from '../css/matchdayLiveScoreCard.css';
import { ASSETS_URL } from "../../../constants/endpoints";
import { MATCHDAY_MODULE_TYPE } from '../modules/matchday/constants/identifiers';
import { getText } from '../../../helpers/localization';
import { getLiveScore } from '../modules/matchday/helpers/matchdayHelper';
import { getMatchdayEventIdsHavingBets } from '../helpers/betHelpers';
const mapStateToProps = (state, ownProps) => {
    return {
        selectedGameIndex: state.vpp.selectedGameIndex,
        selectedEventIndex: state.vpp.selectedEventIndex,
        channelEventBets: state.vpp.channelEventBets
    };
};

class MatchdayLiveScoreCard extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();
        this.highlightScore = [];
        this.previousScore = [];
        this.isFirstTimeLoad = true;
        this.state = {
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            channelEventBets: storeData.vpp.channelEventBets
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                channelEventBets: storeData.vpp.channelEventBets
            });
        }
    }

    componentDidMount() {
        this.interval = setInterval(() => this.setState({ time: Date.now() }), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    findKit(awayKitId, length) {
        let id = '' + awayKitId;
        while (id.length < length) {
            id = '0' + id;
        }
        return id;
    }

    _generateMatchdayEventRow(event, game, serverTimeOffset, index, eventIdsHavingBets, hasBets) {
       if ((hasBets && eventIdsHavingBets.includes(event.eventId)) || (!hasBets && !eventIdsHavingBets.includes(event.eventId))) {
            let homeTeamSilk = ASSETS_URL + "soccer3/silks/Small/Shirts/Team_";
            let awayTeamSilk = ASSETS_URL + "soccer3/silks/Small/Shirts/Team_";
            let liveScore = getLiveScore(event.eventId, event.eventTime, game, serverTimeOffset, true);

            let homeTeamScoreStyle;
            let awayTeamScoreStyle;
            let hyphenStyle;
            let ballStyle = style.hideBall;
            let homeTeamNameStyle = style.team;
            let awayTeamNameStyle = style.team;

            if (liveScore !== undefined && liveScore.score !== this.previousScore[event.eventId]) {

                this.previousScore[event.eventId] = liveScore.score;
                if (!this.isFirstTimeLoad) {
                    homeTeamScoreStyle = style.hideScore;
                    awayTeamScoreStyle = style.hideScore;
                    hyphenStyle = style.hideScore;
                    ballStyle = style.slidingHorizontal;

                    if (liveScore.homeGoal === '1') {
                        this.highlightScore[event.eventId + '_homeGoal'] = 3;
                    } else {
                        this.highlightScore[event.eventId + '_awayGoal'] = 3;
                    }
                }
            }

            if (this.highlightScore[event.eventId + '_homeGoal'] > 0 && this.highlightScore[event.eventId + '_homeGoal'] < 3) {
                homeTeamNameStyle = `${style.team} ${style.teamHighlight}`;
                homeTeamScoreStyle = style.teamHighlight;
            } else if (this.highlightScore[event.eventId + '_awayGoal'] > 0 && this.highlightScore[event.eventId + '_awayGoal'] < 3) {
                awayTeamNameStyle = `${style.team} ${style.teamHighlight}`;
                awayTeamScoreStyle = style.teamHighlight;
            }
            --this.highlightScore[event.eventId + '_homeGoal'];
            --this.highlightScore[event.eventId + '_awayGoal'];
            let containerStyle = (eventIdsHavingBets.length === 0 || eventIdsHavingBets.length >= 8) ? style.eventContainer : `${style.eventContainer} ${style.eventContainerWithBets}`

            return (<div className={containerStyle} key={index}>
                <div className={homeTeamNameStyle}>
                    <div className={style.silkContainerLeft}>
                        <img className={style.image}
                            src={homeTeamSilk + this.findKit(event.homeKitId, 4) + ".png"} />
                    </div>
                    <div className={style.teamNameLeft}>
                        <b>
                            {getText('Matchday_' + event.teamOne, this.props.store)}
                        </b>
                    </div>
                </div>
                <div className={style.liveScore}>
                    <span className={homeTeamScoreStyle}>{liveScore != undefined ? liveScore.score.split("-")[0] : '0'}</span>
                    <span className={hyphenStyle}>{'-'}</span>
                    <span className={awayTeamScoreStyle}>{liveScore != undefined ? liveScore.score.split("-")[1] : '0'}</span>
                    <div className={ballStyle}><img className={style.imageIcon} src={`${ASSETS_URL}football/goalIcon.svg`} /></div>
                </div>
                <div className={awayTeamNameStyle}>
                    <div className={style.teamNameRight}>
                        <b>
                            {getText('Matchday_' + event.teamTwo, this.props.store)}
                        </b>
                    </div>
                    <div className={style.silkContainerRight}>
                        <img className={style.image}
                            src={awayTeamSilk + this.findKit(event.awayKitId, 4) + ".png"} />
                    </div>
                </div>
            </div>);
        }
    }

    render() {
        let games = this.props.store.getState().vpp.games;
        let events = this.props.store.getState().vpp.events;
        let serverTimeOffset = this.props.store.getState().vpp.serverTimeOffset;

        if (games[this.state.selectedGameIndex].type === MATCHDAY_MODULE_TYPE) {
            let selectedMatchday = events[this.state.selectedEventIndex];

            if (selectedMatchday !== undefined && Array.isArray(selectedMatchday)) {
                let game = games[this.state.selectedGameIndex];
                let eventIdsHavingBets = getMatchdayEventIdsHavingBets(this.state, selectedMatchday);

                let teamBoardHavingBets = selectedMatchday.map((event, index) => {
                    return this._generateMatchdayEventRow(event, game, serverTimeOffset, index, eventIdsHavingBets, true);
                });

                let matchdayEventDivider = ( eventIdsHavingBets.length > 0 && eventIdsHavingBets.length < 8 ) ? (<div className={style.divider}>
                    <hr className={style.hr}></hr>
                </div>) : '';

                let teamBoardNotHavingBets = selectedMatchday.map((event, index) => {
                    return this._generateMatchdayEventRow(event, game, serverTimeOffset, index, eventIdsHavingBets, false);
                });
                this.isFirstTimeLoad = false;
                let backgroundImageUrl = `${ASSETS_URL}${game.assetsPath}/backplate.png`
                return (
                    <div className={style.outerContainer} style={{ backgroundImage: `url(${backgroundImageUrl})` }}>
                        <div className={style.title}>{getText('MATCH_IN_PROGRESS', this.props.store)}</div>
                        <div className={style.mainContainer}>
                            {teamBoardHavingBets}
                            {matchdayEventDivider}
                            {teamBoardNotHavingBets}
                        </div>
                    </div>
                );
            } else {
                return '';
            }
        } else {
            return '';
        }
    }
}

export default connect(mapStateToProps)(MatchdayLiveScoreCard);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/matchdayLiveScoreCard.js